import React from 'react';
import { useTranslation } from 'react-i18next';
import { Document, DocumentType } from '../../../interfaces/customer-api';
import { DocumentSection } from './DocumentSection';
import { PicturesSection } from './PicturesSection';

interface DocumentsProps {
    documents: Document[];
}

export const StockEquipmentDocuments: React.FC<DocumentsProps> = ({ documents }: DocumentsProps) => {
    const { t } = useTranslation('StockEquipment');

    const specifications = documents.filter((d) => d.type === DocumentType.Specification);
    const dataSheets = documents.filter((d) => d.type === DocumentType.DataSheet);
    const pictures = documents.filter((d) => d.type === DocumentType.Picture);
    const supportedImageTypes = ['jpg', 'jpeg', 'png', 'svg', 'gif', 'webp'];

    // TODO: Remove once previously unsupported images are replaced
    const isAnyUnsupportedImages = pictures.some((doc) =>
        !supportedImageTypes.includes(doc.name?.split('.').pop()?.toLowerCase() || ''),
    );

    return (
        <>
            <h3>{t('Documents')}</h3>
            {specifications.length > 0 && <DocumentSection title={t('Specifications')} docs={specifications} displayName={t('Specification')}/>}
            {dataSheets.length > 0 && <DocumentSection title={t('Datasheets')} docs={dataSheets} displayName={t('Datasheet')}/>}
            {pictures.length > 0 && !isAnyUnsupportedImages && <PicturesSection docs={pictures} />}
            {pictures.length > 0 && isAnyUnsupportedImages && <DocumentSection title={t('Pictures')} docs={pictures} displayName={t('Picture')}/>}
        </>
    );
};
